// Craft-neutral public capability contracts.
// These contracts intentionally describe observable capability data only.
// Dymistrz smoking vocabulary stays behind product adapters.

function required(value,label){const v=String(value??'').trim();if(!v)throw new TypeError(label+' is required');return v;}
function list(value,label){if(!Array.isArray(value))throw new TypeError(label+' must be an array');return Object.freeze([...value]);}

export const CraftSessionPhase=Object.freeze({
  DRAFT:'draft',PLANNED:'planned',PREPARATION:'preparation',READY:'ready',
  ACTIVE:'active',RESTING:'resting',COMPLETED:'completed',CANCELLED:'cancelled'
});

export function createCraftRecipePlan({id,title,items=[],stages=[],targets=[],metadata=null}={}){
  return Object.freeze({id:required(id,'id'),title:required(title,'title'),items:list(items,'items'),stages:list(stages,'stages'),targets:list(targets,'targets'),metadata:metadata&&typeof metadata==='object'?Object.freeze({...metadata}):null});
}

export function createCraftSessionSnapshot({id,phase,title=null,plannedStartAt=null,plannedEndAt=null,sourceRecipeId=null,sourceSessionId=null}={}){
  const normalized=required(phase,'phase');
  if(!Object.values(CraftSessionPhase).includes(normalized))throw new TypeError('Unsupported craft session phase');
  return Object.freeze({id:required(id,'id'),phase:normalized,title:title==null?null:String(title),plannedStartAt,plannedEndAt,sourceRecipeId,sourceSessionId});
}

export function createCraftProcessSnapshot({session,items=[],stages=[],targets=[],events=[],outcome=null}={}){
  return Object.freeze({session:createCraftSessionSnapshot(session),items:list(items,'items'),stages:list(stages,'stages'),targets:list(targets,'targets'),events:list(events,'events'),outcome});
}

export function assertCraftPlanProvider(provider){
  if(!provider||typeof provider.toCraftRecipePlan!=='function'||typeof provider.createSessionFromPlan!=='function')throw new TypeError('Craft plan provider contract is incomplete');
  return provider;
}

export function assertCraftRepeatProvider(provider){
  if(!provider||typeof provider.toCraftProcessSnapshot!=='function'||typeof provider.repeatFromCompleted!=='function'||typeof provider.compareRepeat!=='function')throw new TypeError('Craft repeat provider contract is incomplete');
  return provider;
}
